import React, { useState } from "react";
import "./LeaveApplicationHR.css";
import axios from "axios";
import LeaveApplicationHRTable from "./LeaveApplicationHRTable.jsx";
// import LeaveApplicationHRForm from "./LeaveApplicationHRForm.jsx";
import LeaveApplicationHRFormEdit from "./LeaveApplicationHRFormEdit.jsx";
export default function LeaveApplicationHR(props) {
  const [table, setTable] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});
  const handleLeaveApplicationHRSubmit = (event) => {
    event.preventDefault();
    // console.log("id", event.target[0].value, event.target[1].value);
    setTable(true);

    let body = {
      //  CompanyName: event.target[0].value,
      //  Designation:  event.target[1].value,
      //  FromDate:  event.target[2].value,
      //  ToDate:  event.target[3].value,

      Leavetype: event.target[0].value,
      FromDate: event.target[1].value,
      ToDate: event.target[2].value,
      Reasonforleave: event.target[3].value,
      Status: event.target[4].value,
    };
    axios
      .post(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/leave-application-hr/" +
          props.data["_id"],
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        setTable(false);
        setTable(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleAddLeaveApplicationHR = () => {
    // // console.log("clicked1");
    setTable(false);
  };
  const handleEditLeaveApplicationHR = (e) => {
    console.log(e);
    // console.log("clicked6");

    setEditForm(true);
    setEditData(e);
  };
  const handleFormClose = () => {
    // // console.log("clicked1");
    setTable(true);
  };
  const handleEditFormClose = () => {
    // console.log("clicked5");

    setEditForm(false);
  };

  const handleLeaveApplicationHREditUpdate = (info, newInfo) => {
    newInfo.preventDefault();
    console.log("zero data", newInfo.target[0].value);
    let body = {
      Status: newInfo.target[4].value,
    };
    console.log("update", body);
    axios
      .put(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/leave-application-hr/" +
          info["_id"],
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        setTable(false);
        setTable(true);
      })
      .catch((err) => {
        console.log(err);
      });
    setEditForm(false);
  };

  return (
    <React.Fragment>
      {table ? (
        editForm ? (
          <LeaveApplicationHRFormEdit
            onLeaveApplicationHREditUpdate={handleLeaveApplicationHREditUpdate}
            onFormEditClose={handleEditFormClose}
            editData={editData}
          />
        ) : (
          <LeaveApplicationHRTable
            onAddLeaveApplicationHR={handleAddLeaveApplicationHR}
            onEditLeaveApplicationHR={handleEditLeaveApplicationHR}
            data={props.data}
          />
        )
      ) : (
        <div></div>
        //   <LeaveApplicationHRForm
        //     onLeaveApplicationHRSubmit={handleLeaveApplicationHRSubmit}
        //     onFormClose={handleFormClose}
        //     onGenderChange={handleAddFormGenderChange}
        //   />
      )}
    </React.Fragment>
  );
}
